const HeroSection = () => (
  <section className="relative mt-1.5 mb-[26px] overflow-hidden rounded-[28px] bg-linear-135 from-[#061A5C] via-[#0C30A8] via-55% to-[#1F4FE0] text-white">
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      viewBox="0 0 1200 420"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <path
        d="M620 0 C760 90 700 220 860 300 C980 360 1100 330 1200 420 L1200 0 Z"
        fill="#2B5CF0"
        opacity=".55"
      />
      <path
        d="M780 0 C880 120 840 210 960 260 C1060 300 1140 250 1200 300 L1200 0 Z"
        fill="#4A78FA"
        opacity=".45"
      />
      <path
        d="M0 420 C140 330 260 380 380 320 C520 250 560 360 700 420 Z"
        fill="#0A2682"
        opacity=".6"
      />
      <path
        d="M900 420 C960 360 1040 380 1100 330 C1150 290 1180 300 1200 280 L1200 420 Z"
        fill="#0A2682"
        opacity=".5"
      />
    </svg>
    <div className="relative grid items-end gap-4 px-[26px] pt-11 pb-10 min-[901px]:grid-cols-[1.15fr_.85fr] min-[901px]:gap-10 min-[901px]:px-12 min-[901px]:pt-16 min-[901px]:pb-[58px]">
      <h1 className="max-w-[14ch] font-display text-[clamp(34px,4.8vw,60px)] leading-[1.02] font-semibold tracking-[-.035em]">
        Three ways to run Somatiq PACS in your imaging centers
      </h1>
      <p className="max-w-[44ch] text-[#D9E2FF]">
        Pick a deployment model to see where your images live, what your IT team
        provides, and how we take you from first call to go-live. Click any
        component in the diagram for details.
        <span className="mt-4 block font-bold tracking-[.02em] text-white">
          Every second matters. Every detail counts.
        </span>
      </p>
    </div>
  </section>
);

export default HeroSection;
